import type { ReactNode } from "react";

// Focusable so keyboard users can scroll wide content; `relative` keeps absolutely
// positioned children (e.g. sr-only labels) inside it instead of widening the page.
export function ScrollArea({ label, children, className = "" }: { label?: string; children: ReactNode; className?: string }) {
  return (
    <div
      role="region"
      aria-label={label ?? "Scrollable table"}
      tabIndex={0}
      className={`relative overflow-x-auto ${className}`.trim()}
    >
      {children}
    </div>
  );
}
